export const UPDATE_COHORT_ROLES = 'UPDATE_COHORT_ROLES';
export const REMOVE_STAFF_ROLES = 'REMOVE_STAFF_ROLES';
export const REMOVE_STAFF_COHORT = 'REMOVE_STAFF_COHORT';
export const ADD_COHORT_ROLE_START = 'ADD_COHORT_ROLE_START';
export const ADD_COHORT_ROLE_SUCCESS = 'ADD_COHORT_ROLE_SUCCESS';
export const ADD_COHORT_ROLE_FAILURE = 'ADD_COHORT_ROLE_FAILURE';
export const REMOVE_COHORT_ROLE_START = 'REMOVE_COHORT_ROLE_START';
export const REMOVE_COHORT_ROLE_SUCCESS = 'REMOVE_COHORT_ROLE_SUCCESS';
export const REMOVE_COHORT_ROLE_FAILURE = 'REMOVE_COHORT_ROLE_FAILURE';
